import PropTypes from "prop-types"
import PeriodDisplay from "connected-components/dashboard/components/period-display"
import { DRIFT_DATES_SHAPE } from "../../prop-types"

export default function RiskHeader({ context, driftDates }) {
  return <PeriodDisplay context={context} isPerformance={false} driftDates={driftDates} label="Drift Period" />
}

RiskHeader.propTypes = {
  context: PropTypes.object.isRequired,
  driftDates: DRIFT_DATES_SHAPE,
}
